import { initializeHeader } from "./header";
import { loadProjectDataFromApi } from "../data/projectData";
import { getHtml } from "../apis/templateHtml";
import { navigate } from "../router/router";
import { DEFAULT_PAGE_SIZE, UNDISPLAY_ITEM } from "../constant/applicationConstant";
/**
 * 案件情報リスト
 */
let projectData = [];
/**
 * 現在選択されている案件データ
 */
let currentProjectData = null;
/**
 * APIから特定の案件IDの詳細データを取得する関数
 */
async function loadProjectDetailFromApi(projectId) {
    try {
        // loadProjectDataFromApiを使用して重複を避ける
        const apiParam = {
            tenpoNo: "",
            tenpoName: "",
            zoCode: "",
            zoName: "",
            doCode: "",
            doName: "",
            ofcName: "",
            projectNo: projectId,
            businessType: "",
            programName: "",
            projectStatus: "",
            status: "",
            progressStatus: "",
            startDateFrom: "",
            startDateTo: "",
            page: 1,
            pageSize: 1,
            columnPattern: "replacement_detail" // 入替案件詳細パターン（replacement_projectテーブルから全カラム取得）
        };
        const response = await loadProjectDataFromApi(apiParam);
        if (response.projects && response.projects.length > 0) {
            return response.projects[0];
        }
        else {
            console.warn(`案件ID ${projectId} のデータがAPIから取得できませんでした`);
            return null;
        }
    }
    catch (error) {
        console.error('API通信エラー:', error);
        return null;
    }
}
/**
 * 案件IDから案件データを取得する関数（後方互換性のため残す）
 */
function getProjectData(projectId) {
    return projectData.find(project => project.projectNo === projectId) || null;
}
/**
 * 日付フォーマット変換関数（YYYY/M/D → YYYY-MM-DD）
 */
function formatDateForInput(dateStr) {
    if (!dateStr)
        return "";
    // YYYY/M/D または YYYY/MM/DD 形式を YYYY-MM-DD に変換
    const parts = dateStr.split('/');
    if (parts.length === 3) {
        const year = parts[0];
        const month = parts[1].padStart(2, '0');
        const day = parts[2].padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    return dateStr;
}
/**
 * 入替案件詳細画面のフィールドを更新する関数
 */
function updateReplacementFields(project) {
    const setFieldValue = (id, value) => {
        const element = document.getElementById(id);
        if (element) {
            // UNDISPLAY_ITEMの場合は親要素を非表示にする
            if (value === UNDISPLAY_ITEM) {
                const parentElement = element.closest('.form-group') || element.parentElement;
                if (parentElement) {
                    parentElement.style.display = 'none';
                }
            }
            else {
                element.value = value;
            }
        }
    };
    const setDateFieldValue = (id, value) => {
        const element = document.getElementById(id);
        if (element) {
            // UNDISPLAY_ITEMの場合は親要素を非表示にする
            if (value === UNDISPLAY_ITEM) {
                const parentElement = element.closest('.form-group') || element.parentElement;
                if (parentElement) {
                    parentElement.style.display = 'none';
                }
            }
            else {
                // 値がある場合のみtype="date"に変更（空の場合はtype="text"のまま）
                if (value) {
                    element.type = 'date';
                }
                element.value = value;
            }
        }
    };
    // 案件基本情報
    setFieldValue('案件No', project.projectNo);
    setFieldValue('業務種別', project.businessType);
    setFieldValue('プログラム名', project.programName);
    setFieldValue('件名', project.projectName || '');
    setDateFieldValue('案件開始日', formatDateForInput(project.startDate || ''));
    setFieldValue('設備部担当者', project.equipdeptPerson || '');
    setFieldValue('管理部担当者', project.managedeptPerson || '');
    setFieldValue('建築部担当者', project.constdeptPerson || '');
    setFieldValue('申請区分', project.applicationType || '');
    setFieldValue('事故種別', project.accidentType || '');
    setFieldValue('BOX内部', project.boxInternal || '');
    setFieldValue('BOX外部', project.boxExternal || '');
    setFieldValue('案件進捗', project.projectStatus);
    setFieldValue('設備進捗', project.equipmentProgress || '');
    setDateFieldValue('設備進捗更新日', formatDateForInput(project.equipmentProgressUpdateDate || ''));
    setDateFieldValue('設備案件完了日', formatDateForInput(project.equipmentProjectCompleteDate || ''));
    setFieldValue('案件中止理由', project.projectAbortReason || '');
    setFieldValue('入替案件進捗状況', project.progressStatus || '');
    setFieldValue('受発注ステータス', project.contractOrderStatus || '');
    setFieldValue('MC受付番号', project.mcReceptionNo || '');
    // 店舗基本情報
    setFieldValue('ZO', project.zoName);
    setFieldValue('DO', project.doName);
    setFieldValue('店No', project.storeNo);
    setFieldValue('店名', project.storeName);
    setFieldValue('OFC', project.ofcName || '');
    setFieldValue('契約タイプ', project.contractType);
    setFieldValue('所有区分', project.ownershipType);
    setFieldValue('設備保守制度', project.equipMantePlanCont);
    setFieldValue('空調機保守制度', project.airConditioningMantePlanCont);
    setFieldValue('７カフェ保守制度', project.sevenCafeMantePlanCont);
    setFieldValue('フライヤー保守制度', project.fryerMantePlanCont);
    setFieldValue('食器洗浄機保守制度', project.dishwasherMantePlanCont);
    setFieldValue('スムージー保守制度', project.smoothieEquipMantePlanCont);
    setFieldValue('自動ドアメンテナンス', project.automaticDoorManteCont);
    setFieldValue('店頭看板保守制度', project.storefrontSignMantePlanCont);
    setFieldValue('サインポール保守制度', project.signPoleMantePlanCont);
    // 店舗基本情報（店舗マスタ由来）
    setFieldValue('都道府県', project.prefecture || '');
    setFieldValue('住所漢字', project.address || '');
    setFieldValue('OFC電話番号', project.ofcMobileNumber || '');
    setDateFieldValue('開店年月日', formatDateForInput(project.openStoreDate || ''));
    setDateFieldValue('オリジナル開店年月日', formatDateForInput(project.originalOpenStoreDate || ''));
    setDateFieldValue('閉店年月日', formatDateForInput(project.closedStoreDate || ''));
    // 案件業者情報
    setFieldValue('幹事会社', project.managingCompany || '');
    // 申請基本情報
    setDateFieldValue('Agile受付日', formatDateForInput(project.agileReceiptDate || ''));
    setDateFieldValue('Agile承認日', formatDateForInput(project.agileApproveDate || ''));
    setFieldValue('AgileID', project.agileId || '');
    setDateFieldValue('案件申請書受付日', formatDateForInput(project.projectApplicationReceiptDate || ''));
    setDateFieldValue('案件申請書承認日', formatDateForInput(project.projectApplicationApproveDate || ''));
    setDateFieldValue('コール日', formatDateForInput(project.callDate || ''));
    setDateFieldValue('事故発生日', formatDateForInput(project.accidentDate || ''));
    setFieldValue('代替機対応状況', project.replacementMachineStatus || '');
    setDateFieldValue('現地調査日', formatDateForInput(project.fieldSurveyDate || ''));
    // MC-Web情報
    setFieldValue('故障破損箇所', project.breakdownDamagePart || '');
    setFieldValue('故障破損状況', project.breakdownDamageState || '');
    setFieldValue('故障破損原因', project.breakdownDamageCause || '');
    setFieldValue('過去コール時期', project.pastCallCountSeason || '');
    setFieldValue('過去コール回数', project.pastCallCountCount || '');
    setFieldValue('過去修理状況', project.pastRepairState || '');
    // 見積・費用申請関連
    setDateFieldValue('見積開始登録日', formatDateForInput(project.estimateStartDate || ''));
    setFieldValue('見積回数', project.quotationCnt != null ? String(project.quotationCnt) : '');
    setDateFieldValue('見積依頼日', formatDateForInput(project.quotationRequestDate || ''));
    setDateFieldValue('見積作成日', formatDateForInput(project.quotationCreateDate || ''));
    setDateFieldValue('見積確認日', formatDateForInput(project.quotationConfirmDate || ''));
    setDateFieldValue('見積申請日', formatDateForInput(project.quotationApplyDate || ''));
    setDateFieldValue('見積承認日M', formatDateForInput(project.quotationApprovedDateM || ''));
    setDateFieldValue('見積承認日GM', formatDateForInput(project.quotationApprovedDateGm || ''));
    setDateFieldValue('決裁開始登録日', formatDateForInput(project.approvalStartDate || ''));
    setFieldValue('費用申請書No', project.costClaimNo || '');
    setDateFieldValue('費用申請出力日', formatDateForInput(project.costClaimOutputDate || ''));
    setDateFieldValue('費用申請決裁登録日', formatDateForInput(project.costClaimApprovalRegisterDate || ''));
    setDateFieldValue('費用申請決裁日', formatDateForInput(project.costClaimApprovalDate || ''));
    // 決裁関連
    setFieldValue('搬入稟議書番号', project.carryingInApprovalNo || '');
    setDateFieldValue('搬入稟議書決裁日', formatDateForInput(project.carryingInApprovalDate || ''));
    setFieldValue('搬出稟議書番号', project.carryingOutApprovalNo || '');
    setDateFieldValue('搬出稟議書決裁日', formatDateForInput(project.carryingOutApprovalDate || ''));
    // 貸主承諾関連
    setFieldValue('貸主承諾要否一次', project.lenderConsentRequiredInitialJudge || '');
    setFieldValue('貸主承諾拒否', project.lendersConsentRejection || '');
    setDateFieldValue('貸主承諾依頼日', formatDateForInput(project.lendersConsentRequestDate || ''));
    setDateFieldValue('貸主承諾受付日', formatDateForInput(project.lendersConsentReceiptDate || ''));
    setDateFieldValue('貸主依頼日', formatDateForInput(project.lendersConsentLendersRequestDate || ''));
    setDateFieldValue('貸主承諾書回収日', formatDateForInput(project.lendersConsentFormCollectDate || ''));
    setFieldValue('貸主承諾ステータス', project.lendersConsentState || '');
    setFieldValue('貸主承諾要否', project.lendersConsentFlg || '');
    setFieldValue('既存店管理担当者名', project.inprogressDepartment || '');
    setFieldValue('貸主承諾通知判断', project.consentRequiredProcedureEtc || '');
    setFieldValue('コメント', project.comment || '');
    // 工事基本情報
    setDateFieldValue('日程調整入力日', formatDateForInput(project.carryingInScheduleAdjustInputDate || ''));
    setDateFieldValue('最終納品予定日', formatDateForInput(project.finalDeliveryScheduledDate || ''));
    setDateFieldValue('搬入発注日', formatDateForInput(project.carryingInOrderDate || ''));
    setDateFieldValue('搬出発注日', formatDateForInput(project.carryingOutOrderDate || ''));
    setFieldValue('受注残件数', project.contractRemainningCount != null ? String(project.contractRemainningCount) : '');
    // 完了報告・検収関連
    setDateFieldValue('設備施工開始日', formatDateForInput(project.equipmentConstructionStartDate || ''));
    setDateFieldValue('電源工事完了日', formatDateForInput(project.powerSupplyCompleteDate || ''));
    setDateFieldValue('設備施工完了日', formatDateForInput(project.equipmentConstructionCompleteDate || ''));
    setFieldValue('完了報告残数', project.completionReportRemainningCount != null ? String(project.completionReportRemainningCount) : '');
    setFieldValue('完了報告確認残数担当', project.completionReportConfirmerRemainningCountPerson != null ? String(project.completionReportConfirmerRemainningCountPerson) : '');
    setFieldValue('完了報告承認残数M', project.completionReportApproverRemainningCountM != null ? String(project.completionReportApproverRemainningCountM) : '');
    setFieldValue('完了報告承認残数GM', project.completionReportApproverRemainningCountGm != null ? String(project.completionReportApproverRemainningCountGm) : '');
    setFieldValue('完了件数', project.completionCount != null ? String(project.completionCount) : '');
    setDateFieldValue('最終納品日', formatDateForInput(project.finalDeliveryDate || ''));
    setDateFieldValue('最終完了報告日', formatDateForInput(project.finalCompletionReportDate || ''));
    setDateFieldValue('最終完了報告承認日', formatDateForInput(project.finalCompletionReportApprovedDate || ''));
    // 保険・加害者支払関連
    setFieldValue('保険会社無責認定', project.insuranceCompanyNoLiabilityAuthorize || '');
    setDateFieldValue('加害者入金日', formatDateForInput(project.assailantPaymentDate || ''));
    setDateFieldValue('SEJ保険切替依頼日', formatDateForInput(project.sejInsuranceSwitchingRequestDate || ''));
    setDateFieldValue('SEJ保険入金日', formatDateForInput(project.sejInsurancePaymentDate || ''));
    setFieldValue('経理へ報告', project.accountingReport || '');
    setFieldValue('財務提出月', project.financeSubmitMonth || '');
    setDateFieldValue('支払期限', formatDateForInput(project.paymentDeadline || ''));
    setFieldValue('請求書No', project.invoiceNo || '');
    setDateFieldValue('請求書発送日', formatDateForInput(project.invoiceShippingDate || ''));
    setFieldValue('請求書送付先', project.invoiceDestination || '');
    // 連絡項目
    setFieldValue('備考', project.note || '');
    setFieldValue('予備2', project.reserve2 || '');
    setFieldValue('予備3', project.reserve3 || '');
}
/**
 * 戻るボタンのイベントリスナーを設定する関数
 */
function setBackButton() {
    const backButton = document.getElementById('backButton');
    if (backButton) {
        backButton.addEventListener('click', (e) => {
            e.preventDefault();
            // ルーターを使用して案件一覧画面に戻る
            navigate('/store-list');
        });
    }
}
/**
 * 入替案件詳細の初期化
 */
export const initializeReplacement = async (projectId) => {
    const subContentsElement = document.getElementById('subContents');
    const subContents = await getHtml("/replacement.html");
    if (subContents) {
        // 入替案件詳細画面のHTMLを生成
        subContentsElement.innerHTML = subContents;
        // DOMが更新されるまで少し待ってからヘッダーを初期化
        setTimeout(() => {
            initializeHeader();
        }, 10);
    }
    // 案件IDが指定されている場合、APIから案件データを取得して表示
    if (projectId) {
        // APIから案件詳細データを取得
        currentProjectData = await loadProjectDetailFromApi(projectId);
        if (currentProjectData) {
            // フィールドを更新するために少し遅延を設ける
            setTimeout(() => {
                updateReplacementFields(currentProjectData);
            }, 100);
        }
        else {
            console.error(`案件ID ${projectId} のデータがAPIから取得できませんでした`);
            // フォールバック: 既存のプロジェクトデータから検索
            if (projectData.length === 0) {
                const apiParam = {
                    tenpoNo: "",
                    tenpoName: "",
                    zoCode: "",
                    zoName: "",
                    doCode: "",
                    doName: "",
                    ofcName: "",
                    projectNo: "",
                    businessType: "",
                    programName: "",
                    projectStatus: "",
                    status: "",
                    progressStatus: "",
                    startDateFrom: "",
                    startDateTo: "",
                    page: 1,
                    pageSize: DEFAULT_PAGE_SIZE,
                    columnPattern: "default" // デフォルトパターン（全カラム取得、マスキングのみ適用）
                };
                const response = await loadProjectDataFromApi(apiParam);
                projectData = response.projects;
            }
            currentProjectData = getProjectData(projectId);
            if (currentProjectData) {
                setTimeout(() => {
                    updateReplacementFields(currentProjectData);
                }, 100);
            }
            else {
                console.error(`案件ID ${projectId} に対応するデータが見つかりません`);
            }
        }
    }
    // 戻るボタンにイベントリスナーを設定
    setBackButton();
};
